<template>
  <v-container fluid class="px-0 pt-0 cst-summary">
		<div v-m2-span>
			<div class="my-4 mx-2" v-if="showHeader">
				<div class="d-flex align-center">
					<div class="flex-grow-1 mr-2" style="border-bottom: 1px solid #ccc;"></div>
					<span class="mx-2 font-weight-bold body-1">{{ tableTitle }}</span>
					<div class="flex-grow-1 ml-2" style="border-bottom: 1px solid #ccc;"></div>
				</div>
				<div class="d-flex justify-center align-center">
					<div v-if="!fromModal">
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									depressed
									color="grey"
									small
									icon
									class="mr-1"
									v-show="showShowMainTable"
									v-bind="attrs"
									v-on="on"
									@click.stop="$store.commit('costbreakdown/setCostBreakdownMainTableModal', true)"
								>
									<v-icon>mdi-eye</v-icon>
								</v-btn>
							</template>
							<span>Visualización Rápida Tabla General</span>
						</v-tooltip>
					</div>
					<v-menu
						v-model="colorPickerVisible"
						:close-on-content-click="false"
						offset-y
					>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								icon
								depressed
								color="grey"
								small
								v-bind="attrs"
								v-on="on"
							>
								<v-icon>mdi-palette</v-icon>
							</v-btn>
						</template>
						<v-card>
							<div>
								<div class="pa-2">
									<p class="mb-0 caption font-weight-bold">Selecciona Un Color a Editar</p>
									<p class="mb-1" style="font-size: 10px">Selecciona el color de la tabla que quieres modificar</p>
									<div class="d-flex align-center">
										<v-tooltip bottom
													v-for="(colorVar, key) in colorVars"
													:key="key">
											<template v-slot:activator="{ on, attrs }">
												<v-btn
													depressed
													color="white"
													small
													icon
													v-bind="attrs"
													v-on="on"
													:style="{
														border: activeColorKey === colorVar.value ? '2px solid #000' : '2px solid #cecece',
														marginRight: '5px',
														boxShadow: activeColorKey === colorVar.value ? '0 0 5px rgba(0,0,0,0.3)' : 'none'
													}"
													@click="openColorPicker(colorVar.value)"
												>
													<v-icon :color="colors[colorVar.value]">mdi-circle</v-icon>
												</v-btn>
											</template>
											<span>{{colorVar.text}}</span>
										</v-tooltip>
									</div>
								</div>
								<v-color-picker
									v-model="currentColor"
									dot-size="25"
									hide-sliders
									mode="rgba"
									dense
									show-swatches
									swatches-max-height="100"
								/>
							</div>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn text @click="colorPickerVisible = false">Cerrar</v-btn>
							</v-card-actions>
						</v-card>
					</v-menu>
				</div>
			</div>
			<v-simple-table style="zoom: 90%" class="custom-table-cost caption">
				<template v-slot:default>
					<thead>
						<tr class="header-rows-custom" :style="{ backgroundColor: summaryTableColor, color: calcFontColor(summaryTableColor) }">
							<td style="min-width: 270px; vertical-align: middle;" rowspan="2" class="text-left">
								<div class="d-flex align-center justify-space-between">
									<p class="mb-0 font-weight-bold">{{ tableTitle }}</p>
								</div>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" colspan="3"><p class="text-center mb-0 caption font-weight-bold" >Valores</p></td>
							<!-- <td style="vertical-align: middle;min-width: 130px;" colspan="3"><p class="text-center mb-0 caption font-weight-bold" >Valores CLP</p></td> -->
						</tr>
						<tr class="header-rows-custom" :style="{ backgroundColor: summaryTableColor, color: calcFontColor(summaryTableColor) }">
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[1]"><p class="text-right mb-0 caption font-weight-bold" >Neto</p></td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[2]"><p class="text-right mb-0 caption font-weight-bold" >{{ costsTable.tax?.name }} ({{ costsTable.tax?.value }}%)</p></td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[3]"><p class="text-right mb-0 caption font-weight-bold" >Total</p></td>
							<!-- <td style="vertical-align: middle;min-width: 130px;" :width="colWidths[4]"><p class="text-right mb-0 caption font-weight-bold" >Neto</p></td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[5]"><p class="text-right mb-0 caption font-weight-bold" >{{ costsTable.tax?.name }} ({{ costsTable.tax?.value }}%)</p></td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[6]"><p class="text-right mb-0 caption font-weight-bold" >Total</p></td> -->
						</tr>
					</thead>
					<!-- Main Project -->
					<tbody v-for="(main_project, index) in summaryInfo.mainProjects" :key="'main_project_' + index">
						<tr>
							<td style="min-width: 270px; vertical-align: middle;" class="text-left">
								<div class="d-flex align-center justify-space-between my-1">
									<div class="mb-1">
										<div class="d-flex align-center mb-1">
											<v-chip
												:color="main_project.project_table?.contract?.parent_contract ? '#FF120B' : 'green'"
												text-color="white"
												label
												small
												style="width: 160px;"
												class="px-2 d-flex justify-center">
												<p class="mb-0">{{ main_project.project_table?.contract?.parent_contract ? 'Anexo / Adicional' : 'Tabla General' }}</p>
											</v-chip>
											<v-chip
												color="warning"
												text-color="white"
												label
												small
												v-if="main_project.project_table?.contract?.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES"
												class="ml-2 px-2">
												<p class="mb-0 font-weight-bold">Cerrada</p>
											</v-chip>
										</div>
										<p class="mb-0 caption font-weight-bold text--disabled" v-m2-span>{{ getMainProjectTitle(main_project) }}</p>
										<p class="mb-0 font-weight-bold" v-html="getMainProjectDescription(main_project)"></p>
										<p class="font-weight-bold caption mb-0">{{ main_project.project_table?.contract?.parent_contract ? 'Anexo: ' : 'Contrato: ' }} {{ getProjectCode(main_project.project_table?.contract) }}</p>
									</div>
								</div>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[1]">
								<p class="text-right mb-0 font-weight-bold" >{{getParentItemTotalValueMultiWithTax([main_project.project_table, main_project.surfaces], main_project.project_table?.tax, main_project.project_table?.uf_value?.uf_value).total_cost_uf | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold" >${{getParentItemTotalValueMultiWithTax([main_project.project_table, main_project.surfaces], main_project.project_table?.tax, main_project.project_table?.uf_value?.uf_value).total_cost_clp | toThousandFilter}} CLP</p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[2]">
								<p class="text-right mb-0 font-weight-bold" >{{getParentItemTotalValueMultiWithTax([main_project.project_table, main_project.surfaces], main_project.project_table?.tax, main_project.project_table?.uf_value?.uf_value).tax_value_uf | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold" >${{getParentItemTotalValueMultiWithTax([main_project.project_table, main_project.surfaces], main_project.project_table?.tax, main_project.project_table?.uf_value?.uf_value).tax_value_clp | toThousandFilter}} CLP</p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[3]">
								<p class="text-right mb-0 font-weight-bold" >{{getParentItemTotalValueMultiWithTax([main_project.project_table, main_project.surfaces], main_project.project_table?.tax, main_project.project_table?.uf_value?.uf_value).total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold" >${{getParentItemTotalValueMultiWithTax([main_project.project_table, main_project.surfaces], main_project.project_table?.tax, main_project.project_table?.uf_value?.uf_value).total_cost_clp_taxed | toThousandFilter}} CLP</p>
							</td>
							<!-- <td style="vertical-align: middle;min-width: 130px;" :width="colWidths[4]"><p class="text-right mb-0 caption font-weight-bold" >${{getParentItemTotalValueMultiWithTax([main_project.project_table, main_project.surfaces], costsTable.tax?.value).total_cost_clp | toThousandFilter}}</p></td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[5]"><p class="text-right mb-0 caption font-weight-bold" >${{getParentItemTotalValueMultiWithTax([main_project.project_table, main_project.surfaces], costsTable.tax?.value).tax_value_clp | toThousandFilter}}</p></td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[6]"><p class="text-right mb-0 caption font-weight-bold" >${{getParentItemTotalValueMultiWithTax([main_project.project_table, main_project.surfaces], costsTable.tax?.value).total_cost_clp_taxed | toThousandFilter}}</p></td> -->
						</tr>
					</tbody>
					<!-- Scondary Project -->
					<tbody v-for="secondary_project in summaryInfo.projects" :key="'secondary_project_'+secondary_project.id">
						<tr>
							<td style="min-width: 270px; vertical-align: middle;" class="text-left">
								<div class="d-flex align-center justify-space-between my-1">
									<div class="mb-1">
										<div class="d-flex align-center mb-1">
											<v-chip
												:color="secondary_project.project_table?.contract.addendum_index ? '#FF120B' : 'green'"
												text-color="white"
												label
												small
												style="width: 160px;"
												class="px-2 d-flex justify-center">
												<p class="mb-0">{{ secondary_project.project_table?.contract?.parent_contract ? 'Anexo / Adicional' : 'Tabla General' }}</p>
											</v-chip>
											<v-chip
												color="warning"
												text-color="white"
												label
												small
												v-if="secondary_project.project_table?.contract?.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES"
												class="ml-2 px-2">
												<p class="mb-0 font-weight-bold">Cerrada</p>
											</v-chip>
										</div>
										<p class="mb-0 font-weight-bold">{{secondary_project.project?.name}}</p>
										<p class="font-weight-bold caption mb-0">{{ secondary_project.project_table?.contract?.parent_contract ? 'Anexo: ' : 'Contrato: ' }} {{ getProjectCode(secondary_project.project_table?.contract) }}</p>
									</div>
								</div>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[1]">
								<p class="text-right mb-0 font-weight-bold" >{{getParentItemTotalValueWithTax(secondary_project, secondary_project.project_table?.tax, secondary_project.project_table?.uf_value?.uf_value).total_cost_uf | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold" >${{getParentItemTotalValueWithTax(secondary_project, secondary_project.project_table?.tax, secondary_project.project_table?.uf_value?.uf_value).total_cost_clp | toThousandFilter}} CLP</p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[2]">
								<p class="text-right mb-0 font-weight-bold" >{{getParentItemTotalValueWithTax(secondary_project, secondary_project.project_table?.tax, secondary_project.project_table?.uf_value?.uf_value).tax_value_uf | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold" >${{getParentItemTotalValueWithTax(secondary_project, secondary_project.project_table?.tax, secondary_project.project_table?.uf_value?.uf_value).tax_value_clp | toThousandFilter}} CLP</p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[3]">
								<p class="text-right mb-0 font-weight-bold" >{{getParentItemTotalValueWithTax(secondary_project, secondary_project.project_table?.tax, secondary_project.project_table?.uf_value?.uf_value).total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold" >${{getParentItemTotalValueWithTax(secondary_project, secondary_project.project_table?.tax, stage.project_table?.uf_value?.uf_value).total_cost_clp_taxed | toThousandFilter}} CLP</p>
							</td>
						</tr>
					</tbody>
					<!-- Cost Stages -->
					<tbody v-for="stage in summaryInfo.stages" :key="'stages_'+stage.id">
						<tr>
							<td style="min-width: 270px; vertical-align: middle;" class="text-left">
								<div class="d-flex align-center justify-space-between my-1">
									<div class="mb-1">
										<div class="d-flex align-start mb-1" style="gap: 10px;">
											<v-chip
												:color="stage.project_table?.contract.addendum_index ? '#FF120B' : 'green'"
												text-color="white"
												label
												small
												style="width: 160px;"
												class="px-2 d-flex justify-center">
												<p class="mb-0">{{ stage.project_table?.contract?.parent_contract ? 'Anexo / Adicional' : 'Tabla General' }}</p>
											</v-chip>
											<v-chip
												color="warning"
												text-color="white"
												label
												small
												v-if="stage.project_table?.contract?.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES"
												class="px-2">
												<p class="mb-0 font-weight-bold">Cerrada</p>
											</v-chip>
										</div>
										<div class="d-flex justify-center align-center" style="gap: 10px;">
											<p class="mb-0 caption" :class="stage.active ? 'grey--text' : ''">Incluir en Notas</p>
											<v-btn
												class="px-0"
												icon
												depressed
												small
												:color="stage.active ? 'success' : '#959595'"
												:disabled="stage.project_table?.contract?.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES"
												@click="changeStageStatus(stage.id)"
											>
												<v-icon large>{{stage.active ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off-outline'}}</v-icon>
											</v-btn>
											<p class="mb-0 caption" :class="stage.active ? '' : 'grey--text'">Incluir en Tabla de Costo</p>
										</div>
										<p class="mb-0 font-weight-bold">{{stage.stage?.name}}</p>
										<p class="font-weight-bold caption mb-0">{{ stage.project_table?.contract?.parent_contract ? 'Anexo: ' : 'Contrato: ' }} {{ getProjectCode(stage.project_table?.contract) }}</p>
									</div>
								</div>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[1]">
								<p class="text-right mb-0 font-weight-bold" >{{getParentItemTotalValueWithTax(stage, stage.project_table?.tax, stage.project_table?.uf_value?.uf_value).total_cost_uf | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold" >${{getParentItemTotalValueWithTax(stage, stage.project_table?.tax, stage.project_table?.uf_value?.uf_value).total_cost_clp | toThousandFilter}} CLP</p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[2]">
								<p class="text-right mb-0 font-weight-bold" >{{getParentItemTotalValueWithTax(stage, stage.project_table?.tax, stage.project_table?.uf_value?.uf_value).tax_value_uf | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold" >${{getParentItemTotalValueWithTax(stage, stage.project_table?.tax, stage.project_table?.uf_value?.uf_value).tax_value_clp | toThousandFilter}} CLP</p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[3]">
								<p class="text-right mb-0 font-weight-bold" >{{getParentItemTotalValueWithTax(stage, stage.project_table?.tax, stage.project_table?.uf_value?.uf_value).total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold" >${{getParentItemTotalValueWithTax(stage, stage.project_table?.tax, stage.project_table?.uf_value?.uf_value).total_cost_clp_taxed | toThousandFilter}} CLP</p>
							</td>
						</tr>
					</tbody>
					<!-- Reception Project -->
					<tbody v-if="summaryInfo.reception">
						<tr>
							<td style="min-width: 270px; vertical-align: middle;" class="text-left">
								<div class="d-flex align-center justify-space-between my-1">
									<div class="mb-1">
										<div class="d-flex align-center mb-1">
											<v-chip
												:color="summaryInfo.reception.project_table?.contract.addendum_index ? '#FF120B' : 'green'"
												text-color="white"
												label
												small
												style="width: 160px;"
												class="px-2 d-flex justify-center">
												<p class="mb-0">{{ summaryInfo.reception.project_table?.contract?.parent_contract ? 'Anexo / Adicional' : 'Tabla General' }}</p>
											</v-chip>
											<v-chip
												color="warning"
												text-color="white"
												label
												small
												v-if="summaryInfo.reception.project_table?.contract?.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES"
												class="ml-2 px-2">
												<p class="mb-0 font-weight-bold">Cerrada</p>
											</v-chip>
										</div>
										<p class="mb-0 font-weight-bold">Recepción</p>
										<p class="font-weight-bold caption mb-0">{{ summaryInfo.reception.project_table?.contract?.parent_contract ? 'Anexo: ' : 'Contrato: ' }} {{ getProjectCode(summaryInfo.reception.project_table?.contract) }}</p>
									</div>
								</div>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[1]">
								<p class="text-right mb-0 font-weight-bold" >{{receptionTotalCostSummary.total_cost_uf | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold" >${{receptionTotalCostSummary.total_cost_clp | toThousandFilter}} CLP</p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[2]">
								<p class="text-right mb-0 font-weight-bold" >{{receptionTotalCostSummary.tax_value_uf | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold" >${{receptionTotalCostSummary.tax_value_clp | toThousandFilter}} CLP</p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[3]">
								<p class="text-right mb-0 font-weight-bold" >{{receptionTotalCostSummary.total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold" >${{receptionTotalCostSummary.total_cost_clp_taxed | toThousandFilter}} CLP</p>
							</td>
						</tr>
					</tbody>
					<!-- Cost Specialties -->
					<tbody v-for="specialty in summaryInfo.specialties" :key="'specialties_'+specialty.id">
						<tr>
							<td style="min-width: 270px; vertical-align: middle;" class="text-left">
								<div class="d-flex align-center justify-space-between my-1">
									<div class="mb-1">
										<div class="d-flex align-center mb-1">
											<v-chip
												:color="specialty.project_table?.contract.addendum_index ? '#FF120B' : 'green'"
												text-color="white"
												label
												small
												style="width: 160px;"
												class="px-2 d-flex justify-center">
												<p class="mb-0">{{ specialty.project_table?.contract?.parent_contract ? 'Anexo / Adicional' : 'Tabla General' }}</p>
											</v-chip>
											<v-chip
												color="warning"
												text-color="white"
												label
												small
												v-if="specialty.project_table?.contract?.last_status?.status == contractStatuses.FIRMADO_AMBAS_PARTES"
												class="ml-2 px-2">
												<p class="mb-0 font-weight-bold">Cerrada</p>
											</v-chip>
										</div>
										<p class="mb-0 font-weight-bold">{{specialty.specialty?.name}}</p>
										<p class="font-weight-bold caption mb-0">{{ specialty.project_table?.contract?.parent_contract ? 'Anexo: ' : 'Contrato: ' }} {{ getProjectCode(specialty.project_table?.contract) }}</p>
									</div>
								</div>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[1]">
								<p class="text-right mb-0 font-weight-bold" >{{getParentItemTotalValueWithTax(specialty, specialty.project_table?.tax, specialty.project_table?.uf_value?.uf_value).total_cost_uf | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold" >${{getParentItemTotalValueWithTax(specialty, specialty.project_table?.tax, specialty.project_table?.uf_value?.uf_value).total_cost_clp | toThousandFilter}} CLP</p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[2]">
								<p class="text-right mb-0 font-weight-bold" >{{getParentItemTotalValueWithTax(specialty, specialty.project_table?.tax, specialty.project_table?.uf_value?.uf_value).tax_value_uf | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold" >${{getParentItemTotalValueWithTax(specialty, specialty.project_table?.tax, specialty.project_table?.uf_value?.uf_value).tax_value_clp | toThousandFilter}} CLP</p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[3]">
								<p class="text-right mb-0 font-weight-bold" >{{getParentItemTotalValueWithTax(specialty, specialty.project_table?.tax, specialty.project_table?.uf_value?.uf_value).total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold" >${{getParentItemTotalValueWithTax(specialty, specialty.project_table?.tax, specialty.project_table?.uf_value?.uf_value).total_cost_clp_taxed | toThousandFilter}} CLP</p>
							</td>
						</tr>
					</tbody>
					<!-- Totals -->
					<tbody>
						<tr class="header-rows-custom" :style="{ backgroundColor: colors['footerSummaryTables'], color: calcFontColor(colors['footerSummaryTables']) }">
							<td style="min-width: 270px; vertical-align: middle;" class="text-left">
								<p class="mb-0 font-weight-bold">Total</p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[1]" class="py-2">
								<p class="text-right mb-0 font-weight-bold body-1" >{{ totalProjectCostSummary.total_cost_uf | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold body-1" >${{ totalProjectCostSummary.total_cost_clp | toThousandFilter}} CLP</p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[2]" class="py-2">
								<p class="text-right mb-0 font-weight-bold body-1" >{{ totalProjectCostSummary.tax_value_uf | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold body-1" >${{ totalProjectCostSummary.tax_value_clp | toThousandFilter}} CLP</p>
							</td>
							<td style="vertical-align: middle;min-width: 130px;" :width="colWidths[3]" class="py-2">
								<p class="text-right mb-0 font-weight-bold body-1" >{{ totalProjectCostSummary.total_cost_uf_taxed | toThousandFilter(2)}} UF</p>
								<p class="text-right mb-0 font-weight-bold body-1" >${{ validatedTotal | toThousandFilter}} CLP</p>
							</td>
						</tr>
					</tbody>
				</template>
			</v-simple-table>
		</div>
	</v-container>
</template>

<script>
import { contractStatuses } from '@/components/Helpers/Constants/contract.js'
import { getParentItemTotalValue, getParentItemTotalValueMultiWithTax, getParentItemTotalValueWithTax } from '@/helpers/tablecostHelpers.js'

export default {
	name: 'CostSummaryTable',
	components: {},
	props: {
		project: {
			type: Object,
			required: true
		},
		showShowMainTable: {
			type: Boolean,
			default: true
		},
		showHeader: {
			type: Boolean,
			default: true
		},
		fromModal: {
			type: Boolean,
			default: false
		},
	},
  data() {
    return {
			contractStatuses,
			getParentItemTotalValue,
			getParentItemTotalValueWithTax,
			getParentItemTotalValueMultiWithTax,
			colWidths: ['24%','11%','11%','11%','11%','11%','11%','11%'],
      colorVars: [
        {'value': 'summaryTableColor', 'text': 'Títulos / Cabecera Tabla Resumen'},
				{'value': 'footerSummaryTables', 'text': 'Totales Tabla Resumen'},
      ],
      colorPickerVisible: false,
      activeColorKey: 'summaryTableColor',
    };
  },
	computed: {
		costsTable: {
			get() {
				return this.$store.state.projects.costsTable
			},
			set(value) {
				this.$store.commit('projects/setCostsTable', value)
			}
		},
		validatedTotal() {
			const mathTotalClp = Math.round(parseFloat(this.totalProjectCostSummary.total_cost_clp) || 0)
			const mathTotalTaxClp = Math.round(parseFloat(this.totalProjectCostSummary.tax_value_clp) || 0)
			const total = mathTotalClp + mathTotalTaxClp
			return total
		},
		project_tables() {
			return this.costsTable.project_tables || []
		},
		summaryInfo(){
			let summary = {
				reception: null,
				surfaces: [],
				projects: [],
				stages: [],
				specialties: [],
				tax: this.costsTable.tax,
				mainProjects: []
			};
			
			// Agregar elementos del costsTable principal
			if (this.costsTable.reception || (Array.isArray(this.costsTable.surfaces?.items) && this.costsTable.surfaces.items.length > 0)) {
				const mainProjectSurfaces = Array.isArray(this.costsTable.surfaces?.items) ? this.costsTable.surfaces.items.map(item => ({ ...item, project_table: this.costsTable })) : [];
				summary.mainProjects.push({ 
					...{
						reception: this.costsTable.reception,
						surfaces: mainProjectSurfaces
					},
					project_table: this.costsTable
				});
			}
			if (this.costsTable.reception) {
				summary.reception = { ...this.costsTable.reception, project_table: this.costsTable };
			}
			if (Array.isArray(this.costsTable.surfaces?.items)) {
				summary.surfaces.push(...this.costsTable.surfaces.items.map(item => ({ ...item, project_table: this.costsTable })));
			}
			if (Array.isArray(this.costsTable.projects)) {
				summary.projects.push(...this.costsTable.projects.map(item => ({ ...item, project_table: this.costsTable })));
			}
			if (Array.isArray(this.costsTable.stages)) {
				summary.stages.push(...this.costsTable.stages.map(item => ({ ...item, project_table: this.costsTable })));
			}
			if (Array.isArray(this.costsTable.specialties)) {
				summary.specialties.push(...this.costsTable.specialties.map(item => ({ ...item, project_table: this.costsTable })));
			}
			
			// Agregar elementos de las tablas adicionales
			let project_table_surfaces = []
			this.project_tables.forEach(project_table => {
				if (project_table.reception) {
					summary.reception = { ...project_table.reception, project_table };
				}
				if (Array.isArray(project_table.surfaces?.items)) {
					project_table_surfaces = project_table.surfaces.items.map(item => ({ ...item, project_table }));
					summary.surfaces.push(...project_table_surfaces);
				}
				if (Array.isArray(project_table.projects)) {
					summary.projects.push(...project_table.projects.map(item => ({ ...item, project_table })));
				}
				if (Array.isArray(project_table.stages)) {
					summary.stages.push(...project_table.stages.map(item => ({ ...item, project_table })));
				}
				if (Array.isArray(project_table.specialties)) {
					summary.specialties.push(...project_table.specialties.map(item => ({ ...item, project_table })));
				}
				if (project_table.reception || (Array.isArray(project_table.surfaces?.items) && project_table.surfaces.items.length > 0)) {
					summary.mainProjects.push({ 
						...{
							reception: project_table.reception,
							surfaces: project_table_surfaces
						},
						project_table: project_table
					});
				}
			});
			return summary;
		},
		tableTitle() {
			// if(this.costsTable.contract) {
			// 	const contract = this.costsTable.contract
			// 	if(contract.addendum_index){
			// 		return `Anexo: ${this.contractCode}`	
			// 	}
			// 	return `Tabla Resumen: ${this.contractCode}`
			// }
			return 'Tabla Resumen'
		},
		contractCode() {
			const contract = this.costsTable.contract
			if(contract?.parent_contract){
				let append = ''
				if(contract.addendum_to_contract_id){
					append = ` - ANX Nº ${contract.addendum_index}`
				}
				else if(contract.subcontract_to_contract_id){
					append = ` - SUB Nº ${contract.subcontract_index}`
				}
				return `${contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${contract.parent_contract?.info?.contract_prefix_index} ${append}`
			}
			return `${contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${contract.info?.contract_prefix_index}`
		},
		projectTypeSubtitle() {
			const parentName = this.project?.info?.project_type?.parent?.name || '';
			const categoryName = this.project?.info?.project_type?.category?.name || '';

			if (parentName && categoryName) {
					return `${categoryName} | ${parentName}`;
			}
			return parentName || categoryName || '';
		},
		currentColor: {
			get() {
				return this.colors[this.activeColorKey]
			},
			set(value) {
				this.$store.commit('costbreakdown/setCostTableColorMap', {
					[this.activeColorKey]: value
				});
			}
		},
		colors(){
			return this.$store.state.costbreakdown.costTableColorMap
		},
		summaryTableColor() {
			return this.$store.state.costbreakdown.costTableColorMap.summaryTableColor;
		},
		projectLineAssociations(){
			if(this.project.associations?.associations){
				const project_associations = this.project.associations
				return project_associations.associations.map((association) => {
					return {...association, ...{type_name: this.getAssociationType(association.morphable_type)}}
				})
			}
			return []
		},
		totalProjectCostSummary() {
			let total = {
				total_cost_uf: 0,
				tax_value_uf: 0,
				total_cost_uf_taxed: 0,
				total_cost_clp: 0,
				tax_value_clp: 0,
				total_cost_clp_taxed: 0
			};

			// Sumar mainProjects
			this.summaryInfo.mainProjects.forEach(mainProject => {
				const taxValue = mainProject.project_table?.tax;
				const ufValue = mainProject.project_table?.uf_value?.uf_value;
				const values = getParentItemTotalValueMultiWithTax([mainProject.project_table, mainProject.surfaces], taxValue, ufValue);
				total.total_cost_uf += values.total_cost_uf || 0;
				total.tax_value_uf += values.tax_value_uf || 0;
				total.total_cost_uf_taxed += values.total_cost_uf_taxed || 0;
				total.total_cost_clp += values.total_cost_clp || 0;
				total.tax_value_clp += values.tax_value_clp || 0;
				total.total_cost_clp_taxed += values.total_cost_clp_taxed || 0;
			});

			// Sumar projects
			this.summaryInfo.projects.forEach(project => {
				const taxValue = project.project_table?.tax;
				const ufValue = project.project_table?.uf_value?.uf_value;
				const values = getParentItemTotalValueWithTax(project, taxValue, ufValue);
				total.total_cost_uf += values.total_cost_uf || 0;
				total.tax_value_uf += values.tax_value_uf || 0;
				total.total_cost_uf_taxed += values.total_cost_uf_taxed || 0;
				total.total_cost_clp += values.total_cost_clp || 0;
				total.tax_value_clp += values.tax_value_clp || 0;
				total.total_cost_clp_taxed += values.total_cost_clp_taxed || 0;
			});

			// Sumar stages
			this.summaryInfo.stages.filter(st => st.active).forEach(stage => {
				const taxValue = stage.project_table?.tax;
				const ufValue = stage.project_table?.uf_value?.uf_value;
				const values = getParentItemTotalValueWithTax(stage, taxValue, ufValue);
				total.total_cost_uf += values.total_cost_uf || 0;
				total.tax_value_uf += values.tax_value_uf || 0;
				total.total_cost_uf_taxed += values.total_cost_uf_taxed || 0;
				total.total_cost_clp += values.total_cost_clp || 0;
				total.tax_value_clp += values.tax_value_clp || 0;
				total.total_cost_clp_taxed += values.total_cost_clp_taxed || 0;
			});

			// Sumar specialties
			this.summaryInfo.specialties.forEach(specialty => {
				const taxValue = specialty.project_table?.tax;
				const ufValue = specialty.project_table?.uf_value?.uf_value;
				const values = getParentItemTotalValueWithTax(specialty, taxValue, ufValue);
				total.total_cost_uf += values.total_cost_uf || 0;
				total.tax_value_uf += values.tax_value_uf || 0;
				total.total_cost_uf_taxed += values.total_cost_uf_taxed || 0;
				total.total_cost_clp += values.total_cost_clp || 0;
				total.tax_value_clp += values.tax_value_clp || 0;
				total.total_cost_clp_taxed += values.total_cost_clp_taxed || 0;
			});

			// Sumar reception si existe
			if (this.summaryInfo.reception) {
				const taxValue = this.summaryInfo.reception.project_table?.tax;
				const ufValue = this.summaryInfo.reception.project_table?.uf_value?.uf_value;
				const values = getParentItemTotalValueWithTax(this.summaryInfo.reception, taxValue, ufValue);
				total.total_cost_uf += values.total_cost_uf || 0;
				total.tax_value_uf += values.tax_value_uf || 0;
				total.total_cost_uf_taxed += values.total_cost_uf_taxed || 0;
				total.total_cost_clp += values.total_cost_clp || 0;
				total.tax_value_clp += values.tax_value_clp || 0;
				total.total_cost_clp_taxed += values.total_cost_clp_taxed || 0;
			}

			return total;
		},
		receptionTotalCostSummary() {
			const values = getParentItemTotalValueWithTax(this.summaryInfo.reception, this.summaryInfo.reception?.project_table?.tax, this.summaryInfo.reception?.project_table?.uf_value?.uf_value)
			return values;
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		dayUfValue(){
			return this.$store.state.general.dayUfValue
		},
		ufValue(){
			return this.selectedUfValue || 40000
		},
		ufValues(){
			return this.$store.state.general.posteriorDaysUf
		},
		companyCostSpecialties(){
			return this.$store.state.costbreakdown.companiesCostCategories
		},
		companySpecialties(){
			return this.$store.state.costbreakdown.companiesSpecialties
		},
		costProjects(){
			return this.$store.state.costbreakdown.companiesBaseProjects
		},
		costSpecialties(){
			return this.$store.state.costbreakdown.companiesCostSpecialties
		},
		costGeneralSubCategories(){
			return this.$store.state.costbreakdown.companiesCostGeneralSubCategories
		},
	},
	watch: {
	},
	mounted(){
	},
  methods: {
		getMainProjectDescription(mainProject){
			return mainProject?.project_table?.project_cost_info?.title || ''
		},
		getMainProjectTitle(mainProject){
      const parentName = mainProject?.project_table?.contract?.info?.project_type?.parent?.name || this.project?.info?.project_type?.parent?.name || '';
      const categoryName = mainProject?.project_table?.contract?.info?.project_type?.category?.name || this.project?.info?.project_type?.category?.name || '';
			const projectTypeName = mainProject?.project_table?.contract?.info?.project_type?.name
      
      if (parentName && categoryName) {
        return `${categoryName} | ${parentName} | ${projectTypeName}`;
      }
      return parentName || categoryName || '';
		},
		changeStageStatus(stageId){
			// Buscar en stages principales
			let foundIndex = this.costsTable.stages.findIndex(st => st.id === stageId)

			if (foundIndex !== -1) {
				const stage = this.costsTable.stages[foundIndex]
				this.$set(stage, 'active', !stage.active)
				return
			}

			// Buscar dentro de project_tables
			for (let i = 0; i < this.costsTable.project_tables.length; i++) {
				const projectTable = this.costsTable.project_tables[i]
				const stageIndex = projectTable.stages.findIndex(st => st.id === stageId)

				if (stageIndex !== -1) {
					const stage = projectTable.stages[stageIndex]
					this.$set(stage, 'active', !stage.active)
					return
				}
			}
		},
		totalMainArqProject(costsTable){
			const values = getParentItemTotalValueMultiWithTax([costsTable, costsTable.surfaces], costsTable.tax?.value, costsTable.uf_value?.uf_value);
			return values;
		},
		getProjectCode(contract) {
			if(contract?.parent_contract){
				let append = ''
				if(contract.addendum_to_contract_id){
					append = ` - ANX Nº ${contract.addendum_index}`
				}
				else if(contract.subcontract_to_contract_id){
					append = ` - SUB Nº ${contract.subcontract_index}`
				}
				return `${contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${contract.parent_contract?.info?.contract_prefix_index} ${append}`
			}
			return `${contract.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${contract.info?.prefix?.prefix} ${contract.info?.contract_prefix_index}`
		},
		calcFontColor(backgroundColor){
			if (!backgroundColor) return '#000';
			let hex = backgroundColor.replace('#', '');
			if (hex.length === 3) {
				hex = hex.split('').map(char => char + char).join('');
			}
			const r = parseInt(hex.substring(0, 2), 16);
			const g = parseInt(hex.substring(2, 4), 16);
			const b = parseInt(hex.substring(4, 6), 16);
			const brightness = (r * 299 + g * 587 + b * 114) / 1000;
			return brightness > 128 ? '#000' : '#fff';
		},
    openColorPicker(key) {
      this.activeColorKey = key
      this.colorPickerVisible = true
    },
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
  },
};
</script>

<style scoped>
	.costbreakdown-detail-table{
		table-layout: fixed;
		width: 100%;
	}
	tr.no-hover-cells,
	tr.no-hover-cells td {
		background-color: inherit !important;
	}
	.action-container{
		width: 60px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	.custom-table-cost table{
		table-layout: fixed;
		width: 100%;
	}
	.custom-table-cost table .main-row{
		border-top: 2px solid #bcbcbc;
		border-bottom: 2px solid #bcbcbc;
	}
	.custom-table-cost table .header-rows-custom{
		/* background: rgb(120, 120, 120); */
		color: white;
		font-size: 10px;
		font-weight: bold;
	}
	.custom-table-cost table tbody tr.header-rows-custom td,
	.custom-table-cost table thead tr.header-rows-custom td{
		height: 25px;
	}
	.custom-table-cost table .header-rows-custom:hover{
		/* background: rgb(103, 103, 103) !important; */
	}
	.custom-table-cost table .header-rows-custom.indigo:hover{
		background: #3f51b5 !important;
	}
	.custom-table-cost table .header-rows-custom.green:hover{
		background: #409242 !important;
	}
	/deep/.costbreakdown-detail-table,
	/deep/.costbreakdown-detail-table td{
		vertical-align: top;
	}
	/deep/.costbreakdown-detail-table:hover {
		background-color: rgb(235, 235, 235);
	}
</style>
<style>
	.custom-table-cost table {
		border-collapse: collapse;
	}
	.custom-table-cost table td{
		border: 1px solid #ccc;
	}
</style>